import React, { FC } from 'react';
import { UseControllerProps } from 'react-hook-form';
import Link from 'next/link';
import { useRouter } from 'next/router';
import useProfileCareer from '@repository/profiles/useProfileCareer';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useInsightResumeLog } from '@repository/insight/useInsight';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface ResultProps extends UseControllerProps {
  result: {
    jobTitle?: string;
    jobGroup?: string;
    locations?: string;
    salary?: string;
    workingPreference?: string;
  };
}

const ComponentLogId = 'btn_preferred_profile_confirm';

const Result: FC<ResultProps> = ({ result }) => {
  const { jobTitle, jobGroup, locations, salary, workingPreference } = result;
  const { data: userInfo } = useUserInfo();
  const { data: profileCareer } = useProfileCareer(!!userInfo?.id);
  const { mutateAsync: fetchLog } = useInsightResumeLog();
  const { pathname } = useRouter();

  const handleClickSave = async () => {
    await fetchLog({
      action: 'CLICK',
      actionSource: pathname,
      actionComponent: ComponentLogId,
    });
  };

  return (
    <div className={cx('wrap')}>
      <div className={cx('questionTitle')}>프로필 작성을 완료했습니다!</div>

      <div className={cx('resultArea')}>
        <div className={cx('resultList')}>
          {profileCareer && profileCareer?.careers.length > 0 ? (
            <>
              <span className={cx('highlight')}>총 {profileCareer.totalCareerPeriodText}의 경력</span>을 보유하고 있으며
            </>
          ) : (
            <>
              <span className={cx('highlight')}>신입</span>으로
            </>
          )}
          <br />
          <span className={cx('highlight')}>{jobGroup} 직군</span>에
          <span className={cx('highlight')}> {jobTitle} 직무</span>로 취업을 희망합니다.
          <br />
          <span className={cx('highlight')}>{locations}</span>에서 근무가 가능하고
          <br />
          희망 연봉은 <span className={cx('highlight')}>{salary}</span>입니다.
        </div>
        <div className={workingPreference ? cx('freeText') : ''}>{workingPreference}</div>
      </div>

      {/* 공지 */}
      <div className={cx('notice')}>입력하신 정보는 언제든지 내 프로필에서 수정할 수 있습니다.</div>

      {/* 프로필 확인 링크 */}
      <div className={cx('btnArea')}>
        <Link href={RouteUrl.PROFILE} legacyBehavior>
          <button role="button" className={cx('btnBasic')} onClick={handleClickSave}>
            프로필 확인하기
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Result;
